import { post } from "./Fetching";

const deleteQuoteItems = (attempt_id, quote_group_id, quote_item_ids) => {
  return post("/quote_groups/delete_quote_items.json", {
    attempt_id,
    quote_group_id,
    quote_item_ids
  });
};

export { deleteQuoteItems };
